import * as React from "react";

import { Colors } from "../../core/utils/Colors";
import { AudioStore } from "../../stores";

import { renderLine, renderImage } from "./CategoryItemCardContainer";

import { Row, Col } from "../../layout";
import { ActivityCategoryItem } from "models/customLists/CategoryItem";

interface CategoryItemCardProps {
    height: number;
    categoryItem: ActivityCategoryItem;
    audioStore?: AudioStore;
    longestItem?: number;
    showWrongAnswers?: boolean;
}
export const ImageOnlyCard = (props: CategoryItemCardProps) => {
    return (
        <Col xs={true}>
            {props.categoryItem.imageURL && renderImage(props.categoryItem.imageURL, props.height * 0.8)}
        </Col>
    );
};

export const TextOnlyCard = (props: CategoryItemCardProps) => {
    const { longestItem, audioStore, categoryItem, height } = props;

    let textSize = 0.3;
    if (longestItem > 12) {
        textSize = 0.25;
    }
    return (
        <Col xs={true}>
            {renderLine(categoryItem.answer.text, audioStore, categoryItem.answer.audio, height * textSize)}
        </Col>
    );
};

export const VocabularyCard = (props: CategoryItemCardProps) => {
    const { longestItem, audioStore, categoryItem, height } = props;

    let textSize = 0.2;
    if (longestItem > 20) {
        textSize = 0.17;
    }

    return (
        <Col xs={true}>
            {categoryItem.imageURL && renderImage(categoryItem.imageURL, height * 0.6)}
            <div style={{ paddingTop: 7 }}>
                {renderLine(categoryItem.answer.text, audioStore, categoryItem.answer.audio, height * textSize)}
            </div>
        </Col>
    );
};

export const ExpressionCard = (props: CategoryItemCardProps) => {
    const { longestItem, audioStore, categoryItem, showWrongAnswers } = props;

    let textSize = 0.3;
    if (longestItem > 25) {
        textSize = 0.15;
    } else if (longestItem > 15) {
        textSize = 0.2;
    }

    let question = renderLine(
        categoryItem.question.text,
        audioStore,
        categoryItem.question.audio,
        props.height * textSize
    );
    let answer = renderLine(categoryItem.answer.text, audioStore, categoryItem.answer.audio, props.height * textSize);
    let wrongAnswers = renderWrongAnswers(audioStore, categoryItem, props.height);

    return (
        <Col xs={12}>
            <Row center="xs">{question}</Row>
            {renderImage(categoryItem.imageURL, props.height * 0.6)}
            <Row center="xs">{answer}</Row>
            {showWrongAnswers && <Row center="xs">{wrongAnswers}</Row>}
        </Col>
    );
};

export const ExpressionTextOnlyCard = (props: CategoryItemCardProps) => {
    const { longestItem, audioStore, categoryItem, showWrongAnswers } = props;

    let textSize = 0.3;
    if (longestItem > 25) {
        textSize = 0.2;
    } else if (longestItem > 15) {
        textSize = 0.25;
    }

    let question = renderLine(
        categoryItem.question.text,
        audioStore,
        categoryItem.question.audio,
        props.height * textSize
    );
    let answer = renderLine(categoryItem.answer.text, audioStore, categoryItem.answer.audio, props.height * textSize);
    let wrongAnswers = renderWrongAnswers(audioStore, categoryItem, props.height);

    return (
        <Col xs={12}>
            <Row center="xs">{question}</Row>
            <Row center="xs">{answer}</Row>
            {showWrongAnswers && wrongAnswers && <Row center="xs">{wrongAnswers}</Row>}
        </Col>
    );
};

export const LessonCard = (props: CategoryItemCardProps) => {
    const { longestItem, audioStore, categoryItem, showWrongAnswers, height } = props;

    let textSize = 0.2;
    if (longestItem > 25) {
        textSize = 0.15;
    } else if (longestItem > 15) {
        textSize = 0.18;
    }

    return (
        <Col xs={true}>
            <Row middle="xs">
                <Col xs={5}>
                    {renderImage(categoryItem.imageURL, height * 0.8)}
                    {categoryItem.useImageAsVocabularyItem &&
                        renderLine(categoryItem.vocab.text, audioStore, categoryItem.vocab.audio, height * 0.15)}
                </Col>
                <Col xs={7} style={{ paddingTop: height * 0.1 }}>
                    {renderLine(categoryItem.question.text, audioStore, categoryItem.question.audio, height * textSize)}
                    {renderLine(
                        categoryItem.questionsAnswer.text,
                        audioStore,
                        categoryItem.questionsAnswer.audio,
                        height * textSize
                    )}
                    {showWrongAnswers && renderWrongAnswers(audioStore, categoryItem, height)}
                </Col>
            </Row>
        </Col>
    );
};

export const renderWrongAnswers = (audioStore: AudioStore, categoryItem: ActivityCategoryItem, height: number) => {
    if (!categoryItem.wrong1 && !categoryItem.wrong2 && !categoryItem.wrong3) {
        return null;
    }

    if (categoryItem.wrong1?.text === "" && categoryItem.wrong2?.text === "" && categoryItem.wrong3?.text === "") {
        return null;
    }

    return (
        <div style={{ color: Colors.red, paddingBottom: 15, paddingTop: 10 }}>
            <Row center="xs">
                {renderLine(categoryItem.wrong1.text, audioStore, categoryItem.wrong1.audio, height * 0.11)}
            </Row>
            <Row center="xs">
                {renderLine(categoryItem.wrong2.text, audioStore, categoryItem.wrong2.audio, height * 0.11)}
            </Row>
            <Row center="xs">
                {renderLine(categoryItem.wrong3.text, audioStore, categoryItem.wrong3.audio, height * 0.11)}
            </Row>
        </div>
    );
};
